import DefaultSubTitleContainer from "./styles";
export default DefaultSubTitleContainer;
